import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {Pipeline} from "../types.ts";
import {usePipeline} from "../hooks/usePipeline.ts";


export const AddFormDrawer = (props: DrawerProps) => {

    const {
        record,
        createRecord,
    } = usePipeline();

    return (
        <FormDrawer
            record={record ?? {} as Pipeline}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
